import { VField } from '../../components/Fields'
import { Bilancia } from '../../types'
import { getLabelTipoBilancia } from '../../utils/utils'

export default function FormRichiesta({ bilancia }: { bilancia: Bilancia | undefined }) {
  return (
    <div className="row">
      <div className="col-12">
        <div className="heading-h3">
          {bilancia?.matricola} {bilancia?.sigla ? `(${bilancia.sigla})` : ''} - {getLabelTipoBilancia(bilancia?.tipo_bilancia)}
        </div>
        <div className='p-md text-body-secondary'>
          {bilancia?.cliente_ragione_sociale} - {bilancia?.sede_data?.numero_rea} - {bilancia?.reparto}
        </div>
      </div>
      <div className="col-12 mt-3">
        <VField
          name="data_richiesta"
          label="Data richiesta"
          required
          type="date"
        />
      </div>
      <div className="col-12">
        <VField name="note" label="Note" as="textarea" />
      </div>
    </div>
  )
}
